import { render, staticRenderFns } from "./BulkBookingForm.vue?vue&type=template&id=2bc113c8&scoped=true"
import script from "./BulkBookingForm.vue?vue&type=script&lang=js"
export * from "./BulkBookingForm.vue?vue&type=script&lang=js"
import style0 from "./BulkBookingForm.vue?vue&type=style&index=0&id=2bc113c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc113c8",
  null
  
)

export default component.exports